import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-employee-note',
  templateUrl: './employeeNote.component.html',
  styleUrls: ['./employeeNote.component.scss']
})
export class EmployeeNoteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<EmployeeNoteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
    }


  ngOnInit(): void {

  }

  closeDialog() {
    this.dialogRef.close(null);
  }

}
